import { isMobile } from "./helper"
import SiteHeader from "./siteHeader"
import { toggleMenu, addSticky, closeMenu } from "./navigation"
import FloatLabels from "./forms/float-labels"
import $ from "jquery"

window.addEventListener("load", () => {
  new SiteHeader()
  new FloatLabels()

  toggleMenu()

  if (isMobile()) {
    closeMenu()
    addSticky()
  }
})

window.onresize = () => {
  if (isMobile()) {
    closeMenu()
    addSticky()
  }
}

const invisible = document.querySelectorAll(".invisible")
const loadMore = document.getElementById("load-more")
let index = 0
console.log(invisible)
loadMore.onclick = e => {
  e.preventDefault()
  const forLength = index + 14
  if (index < invisible.length) {
    for (index; index <= forLength; index++) {
      if( !invisible[index]) {
        loadMore.innerHTML = "zwiń"
        loadMore.classList.add("collapse")
      } else {
        invisible[index].classList.remove("invisible")
      }
    }
  } else {
    for (let i = 0; i <= invisible.length; i++) {
      index = 0
      invisible[i].classList.add("invisible")
      loadMore.innerHTML = "rozwiń"
      loadMore.classList.remove("collapse")
      window.scrollBy(0, 50)
    }
  }
}

// function handler(entries, observer) {
//   for (const entry of entries) {
//     console.log(entry);
//     console.log(observer);
//     if (entry.isIntersecting) {
//       setTimeout(() => {
//         entry.target.classList.add("visible");
//       }, 500);
//     } else {
//         entry.target.classList.remove("visible");
//     }
//   }
// }
//
// let observer = new IntersectionObserver(handler);
// const elements = document.querySelectorAll(".single-realisation");
// elements.forEach(item => {
//   observer.observe(item);
// });
